'use es6';

import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import PortalIdParser from 'PortalIdParser';
import { getId } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { createDashboard as createDashboardApi } from 'dashboard-lib/public/dashboard/dashboard-dao';
import RequestStatusType from '../constants/RequestStatusType';
import { jsx as _jsx } from "react/jsx-runtime";
export const dashboardCreateNamespace = 'dashboardCreate';

// Action types
const DASHBOARD_CREATE_PENDING = 'DASHBOARD_CREATE_PENDING';
const DASHBOARD_CREATE_SUCCEEDED = 'DASHBOARD_CREATE_SUCCEEDED';
const DASHBOARD_CREATE_FAILED = 'DASHBOARD_CREATE_FAILED';

// Actions
export const createDashboard = (...args) => dispatch => {
  dispatch({
    type: DASHBOARD_CREATE_PENDING
  });
  return createDashboardApi(...args).then(response => {
    const dashboardId = getId(response);
    const dashboardPath = `/view/${dashboardId}`;
    dispatch({
      type: DASHBOARD_CREATE_SUCCEEDED
    });
    const path = `/reports-dashboard/${PortalIdParser.get()}${dashboardPath}`;
    window.location = path;
  }, error => {
    console.error(error);
    dispatch({
      type: DASHBOARD_CREATE_FAILED,
      // Show floating alert UIFloatingAlert via ReduxMessenger
      // https://git.hubteam.com/HubSpot/ReduxMessenger/tree/master/#usage
      meta: {
        notification: {
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dashboard-actions.createDashboard.error.description"
          }),
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dashboard-actions.createDashboard.error.title"
          }),
          type: 'danger'
        }
      }
    });
  });
};

// Reducer
const initialState = {
  requestStatus: RequestStatusType.UNINITIALIZED,
  meta: null
};
export const dashboardCreateReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_CREATE_PENDING:
      return Object.assign({}, state, {
        requestStatus: RequestStatusType.PENDING
      });
    case DASHBOARD_CREATE_SUCCEEDED:
      return Object.assign({}, state, {
        requestStatus: RequestStatusType.SUCCEEDED
      });
    case DASHBOARD_CREATE_FAILED:
      return Object.assign({}, state, {
        requestStatus: RequestStatusType.FAILED
      });
    default:
      return state;
  }
};